import { combineReducers } from 'redux'
import app_token from './app_token'
import plan from './plan'
import risk from './risk'
import reset_password from './password/reset'
import change_password from './password/change'
import control from './control'
import tags from './tags'

const RiskPlanningApp = combineReducers({
  app_token: app_token,
  plan: plan,
  risk: risk,
  reset_password: reset_password,
  change_password: change_password,
  control: control,
  tags: tags
})

export default RiskPlanningApp



// WEBPACK FOOTER //
// ./src/reducers/index.js